var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0C14.0416 0 0.166626 13.875 0.166626 30.8333C0.166626 47.7917 14.0416 61.6667 31 61.6667C47.9583 61.6667 61.8333 47.7917 61.8333 30.8333C61.8333 13.875 47.9583 0 31 0ZM27.3 45.6333L15.8916 34.225L20.2083 29.9083L26.9916 36.6917L44.875 17.8833L49.5 22.5083L27.3 45.6333Z",
    fill: "#0EAF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessLogo);
export default __webpack_public_path__ + "static/media/success-logo.c60967af930fb48ab9dd341df59f5440.svg";
export { ForwardRef as ReactComponent };